import { match } from 'ts-pattern';

import type { SuperbillLocation } from '@/entities/client-billing-settings';

export const formatSuperbillLocationLabel = (
    location: SuperbillLocation,
    defaultLocationName: string,
): string =>
    match(location)
        .with('DEFAULT_LOCATION', () => `Default location (${defaultLocationName})`)
        .with('SERVICE_LOCATION', () => 'Service location')
        .exhaustive();
